import {permissionsEnabled} from './permissionsEnabled';

export const legacyPermissionsEnabled = () => !permissionsEnabled();
